import React, { Component } from 'react'
import { getUser } from '../../actions/session';
import Axios from 'axios';
import Select from 'react-select';
import { TABLE_STATS, CARRIER_TABLE_STATS } from '../../config/rest_endpoints';
import Container from '../common/application_container'
import CustomLoader from '../common/loader';
import ChangeCarrierStats from './changeCarrierStatsReport';
import ReactTooltip from 'react-tooltip';
import { fmtDollar4, fmtMins, fmtInt } from '../common/formatters';



export class CarrierStatsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            data: [],
            isExpend: false,
            newData: [],
            expendId: '',
            isGetting:false,
            isDescOrder:false,
            isAsceOrder:false
        }
        this.renderYesterday = this.renderYesterday.bind(this)
        this.closeExpand = this.closeExpand.bind(this)
        this.handleSortingNumberDesc = this.handleSortingNumberDesc.bind(this)
        this.handleSortingNumberAsce = this.handleSortingNumberAsce.bind(this)
        this.handleSortingName = this.handleSortingName.bind(this)
    }

    // componentWillMount() {
    //     this.getTableStats()
    // }

    componentDidMount() {
        // this.interval = setInterval(() => {
        //     this.getTableStats()
        // }, 100000)
        // this.getTableStats()
    }

    // componentWillUnmount() {
    //     clearInterval(this.interval)
    // }

    getTableStats() {
        const { data, User } = this.state
        this.setState({isGetting:true})
        var payload = {
            
            "startDate": 1623027660,
            "endDate": 1623352003
        
    }
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.post(`${CARRIER_TABLE_STATS}`,payload, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                console.log(`resp`, resp)
                this.setState({
                    data: resp,
                    isGetting:false
                })
                this.handleSortingNumberAsce()
            }
        })
    }

    renderYesterday(stats, id) {
        console.log('id', id)
        this.setState({
            isExpend: true,
            newData: stats,
            expendId: id

        })
    }

    handleSortingName(name) {
        console.log('name :>> ', name);
        const { data } = this.state
        function sortOn(name) {
            return function (a, b) {
                if (a[name].toLowerCase() < b[name].toLowerCase()) {
                    return -1;
                } else if (a[name].toLowerCase() > b[name].toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }
        data.sort(sortOn(name))
        console.log('data :>> ', data);
        this.setState({ data })
    }

    handleSortingNumberDesc(num) {
        console.log('num :>> ', num);
        const { data } = this.state
        data.sort((a, b) => parseInt(a[num])- parseInt(b[num])).reverse()
        this.setState({ data , isDescOrder: true, isAsceOrder:false})
        console.log('int', data)
    }

    handleSortingNumberAsce(num) {
        console.log('num :>> ', num);
        const { data } = this.state
        data.sort((a, b) => parseInt(a[num])- parseInt(b[num]))
        this.setState({ data, isAsceOrder:true, isDescOrder:false  })
        console.log('int', data)
    }

    closeExpand() {
        this.setState({
            isExpend: false,
            expendId: -1
        })
    }

    __renderTable_Stats() {
        const { data, expendId } = this.state

        if (data == undefined || data.length <= 0) {
            return (
                <td colSpan="7" >
                    <p>Nothing to show</p>
                </td>
            )
        }
        else {
            return data.map((stats, idx) => {
                return (
                    <>
                        <tr key={idx} className="left_align">
                            <td><i className="icon-plus-circle2 mr-3 icon-1x" onClick={this.renderYesterday.bind(this, stats, idx)}></i></td>
                            <td><span className="badge bg-blue fs-12">{stats['accountName']}</span></td>
                            {/* <td><span className="text-success-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['sessions']}</td> */}
                            {/* <td><span className="text-success-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['cps']}</td> */}
                            <td style={{textAlign:'right'}}>{stats['ansSeizeRatio'] === 0 ? <> <span className="text-warning-600"><i className="icon-menu-close2 mr-1"></i></span> {stats['ansSeizeRatio']}</> : <> <span className="text-success-600"><i className="icon-menu-close2 mr-1"></i></span> {stats['ansSeizeRatio']}</>}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-history mr-1"></i></span> {stats['avgCallDur']}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-history mr-1"></i></span>{fmtMins(stats['totalCallDuration'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-price-tags mr-1"></i></span>{fmtMins(stats['billedCallDuration'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-split mr-1"></i></span>{fmtInt(stats['duplicateNum'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-phone2 mr-1"></i></span>{fmtInt(stats['totalSuccessfulCalls'])}</td>
                            {/* <td><span className="text-success-600"><i className="icon-feed mr-1"></i></span>{stats['distinctDstCnt']}</td> */}
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-phone-outgoing mr-1"></i></span>{fmtInt(stats['totalDialedCalls'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['avgCallCost'])}</td>
                            <td style={{textAlign:'right'}}><span className="text-success-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['totalCallCost'])}</td>
                        </tr>
                        {expendId === idx ?
                            <tr className="left_align">
                                <td><i className="icon-minus-circle2 mr-3 icon-1x" onClick={this.closeExpand}></i></td>
                                <td><span className="badge bg-warning fs-12">{stats['accountName']}</span></td>
                                {/* <td><span className="text-warning-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['sessions']}</td> */}
                                {/* <td><span className="text-warning-600"><i className="icon-stats-growth2 mr-1"></i></span>{stats['cps']}</td> */}
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-menu-close2 mr-1"></i></span>{stats['ytdAnsSeizeRatio']}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-history mr-1"></i> </span>{stats['ytdAVGCallDur']}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-history mr-1"></i></span>{fmtMins(stats['ytdTotalCallDuration'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-price-tags mr-1"></i></span>{fmtMins(stats['ytdBilledCallDuration'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-split mr-1"></i></span>{fmtInt(stats['ytdDuplicateNum'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-phone2 mr-1"></i></span>{fmtInt(stats['ytdTotalSuccessfulCalls'])}</td>
                                {/* <td><span className="text-warning-600"><i className="icon-feed mr-1"></i></span>{stats['ytdDistinctDstCnt']}</td> */}
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-phone-outgoing mr-1"></i></span>{fmtInt(stats['ytdTotalDialedCalls'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['ytdCallCost'])}</td>
                                <td style={{textAlign:'right'}}><span className="text-warning-600"><i className="icon-coin-dollar mr-1"></i></span>{fmtDollar4(stats['ytdTotalCallCost'])}</td>
                            </tr>
                            : ''}
                    </>
                )
            })
        }
    }



    render() {
        const { selectTime, selectTimeOption,isGetting, isAsceOrder,isDescOrder} = this.state
        return (
            <Container title="Carrier" title1="Stats" icon="fa fa-bars">
                <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                    <div style={{padding:'20px'}}>
                    <ChangeCarrierStats />
                        {/* <ul className="nav nav-tabs nav-tabs-top nav-justified border fs-16">
                            <li className="nav-item"><a href="#top-justified-tab1" className="nav-link active" data-toggle="tab">Live Stats <i className="icon-stats-growth icon-2x ml-2"></i></a></li>
                            <li className="nav-item"><a href="#top-justified-tab2" className="nav-link " data-toggle="tab">Other Stats <i className="icon-design icon-2x ml-2"></i></a></li>
                        </ul>

                        <div className="tab-content">
                            <div className="tab-pane fade active show" id="top-justified-tab1">
                                <div className="card mb-2 mt-2 ">
                                    <div className="table-responsive ">
                                        <table className="table  datatable-basic bg-light border dataTable no-footer">
                                            <thead>
                                                <tr className="left_align" style={{textDecoration: 'underline'}}>
                                                    <th >Yesterday</th>
                                                    <th className="" onClick={this.handleSortingName.bind(this, 'accountName')} >Company </th>
                                                    <th className="" >Session {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this,"sessions")} ></i> :  <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this,'sessions')} style={{marginLeft: '0em'}} ></i>} </th>
                                                    <th className="" >CPS {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this,"CPS")}></i> :  <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this,"CPS")} style={{marginLeft: '0em'}} ></i>}</th>
                                                    <th className="" data-tip={'Answer seizure ratio'} >ASR {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, 'ansSeizeRatio')} ></i> : <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this, 'ansSeizeRatio')} style={{ marginLeft: '0em' }} ></i>}</th>
                                                    <th className="" data-tip={'Average call duration'} >ACD {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, 'avgCallDur')}></i> : <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this, 'avgCallDur')} style={{ marginLeft: '0em' }} ></i>} </th>
                                                    <th className="" data-tip={'Total call duration'} >TCD {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, 'totalCallDuration')}></i> : <i class="fas fa-sort-down ml-2" style={{ marginLeft: '0em' }} onClick={this.handleSortingNumberAsce.bind(this, 'totalCallDuration')} ></i>}</th>
                                                    <th className="" data-tip={'Billed call duration'} >BCD {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, 'billedCallDuration')}></i> : <i class="fas fa-sort-down ml-2" style={{ marginLeft: '0em' }} onClick={this.handleSortingNumberAsce.bind(this, 'billedCallDuration')} ></i>}</th>
                                                    <th className="" data-tip={'Duplicate number'} >DN {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, "totalSuccessfulCalls")}></i> : <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this, 'totalSuccessfulCalls')} style={{ marginLeft: '0em' }} ></i>}</th>
                                                    <th className="" data-tip={'Total successful call'} >TSC {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, "totalSuccessfulCalls")}></i> : <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this, 'totalSuccessfulCalls')} style={{ marginLeft: '0em' }} ></i>}</th>
                                                    <th className="" >DDC {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this,"distinctDstCnt")}></i> :  <i class="fas fa-sort-down ml-2"  onClick={this.handleSortingNumberAsce.bind(this,'distinctDstCnt')} style={{marginLeft: '0em'}} ></i>} </th>
                                                    <th className="" data-tip={'Total dialed call'} >TDC {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, "totalDialedCalls")}></i> : <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this, 'totalDialedCalls')} style={{ marginLeft: '0em' }} ></i>}</th>
                                                    <th className="" data-tip={'Average call cost'} >ACC {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, 'avgCallCost')}></i> : <i class="fas fa-sort-down ml-2" onClick={this.handleSortingNumberAsce.bind(this, 'avgCallCost')} style={{ marginLeft: '0em' }} ></i>} </th>
                                                    <th className="" data-tip={'Total call cost'} >TCC {isAsceOrder ? <i class="fas fa-sort-up ml-2" onClick={this.handleSortingNumberDesc.bind(this, "totalCallCost")}></i> : <i class="fas fa-sort-down ml-2" style={{ marginLeft: '0em' }} onClick={this.handleSortingNumberAsce.bind(this, 'totalCallCost')}></i>}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isGetting ? <CustomLoader /> : this.__renderTable_Stats()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                            <div className="tab-pane fade" id="top-justified-tab2">
                               
                            </div>
                        </div> */}
                    </div>
                </div>
                <ReactTooltip type="dark" backgroundColor='#0F172A' place='top' effect="solid" />
            </Container>

        )
    }
}

export default CarrierStatsReport
